"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function parseImageUrl(imageUrl) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '{{imageUrl}}';
  var url = new URL(imageUrl);
  var image = format.replace('{{imageUrl}}', imageUrl).replace('{{imagePath}}', url.pathname);
  var imageWebp = image.replace('.jpg', '.webp');
  var thumb = format.replace('{{imageUrl}}', imageUrl).replace('{{imagePath}}', url.pathname).replace('/image/', '/image/thumbs300x384/');
  var thumbWebp = thumb.replace('.jpg', '.webp');
  return {
    image: image,
    imageWebp: imageWebp,
    thumb: thumb,
    thumbWebp: thumbWebp
  };
}
var _default = exports["default"] = parseImageUrl;